import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { IncidentLawEnforcementOOJModel } from '../models/incident-law-enforcement-ooj.model';

@Injectable()
export class LawEnforcementIncidentOOJService extends IncidentServiceBase<IncidentLawEnforcementOOJModel> {
    constructor() {
        super('IncidentLawEnforcementOOJ', () => new IncidentLawEnforcementOOJModel());
    }

    public getLookups() {
        return this.get('Incident/IncidentLawEnforcementOOJ/lookups');
    }
}
